<template>
  <div class="container">
    <!-- 整体容器 -->
    <el-container style="height: 85vh; position: relative">
      <!-- 上半部分 -->

      <div class="top-left">
        <h3>通知公告</h3>
        <ul>
          <li
            v-for="(notice, index) in notices"
            :key="index"
            @click="showNoticeDetail(notice)"
          >
            <span>{{ notice.content | truncate(50) }}</span>
            <span class="timestamp">{{ notice.createdAt | formatDate }}</span>
          </li>
        </ul>
      </div>

      <div class="top-right">
        <Echarts :user-forms="users" :transit-records="transits" />
      </div>

      <!-- 下半部分 -->

      <div class="bottom-left">
        <!-- 左下部分展示 UserSignin 组件 -->
        <UserSignin />
      </div>

      <div class="bottom-right">
        <!-- 右下部分展示 OrderSignin 组件 -->
        <OrderSignin />
      </div>

      <!-- 公告详情弹窗 -->
      <el-dialog :visible.sync="dialogVisible" width="50%">
        <h4>公告详情</h4>
        <p>
          <strong>创建时间：</strong>{{ selectedNotice.createdAt | formatDate }}
        </p>
        <p><strong>公告内容：</strong>{{ selectedNotice.content }}</p>
        <div style="text-align: right; margin-top: 20px">
          <el-button type="danger" @click="deleteNotice" icon="el-icon-delete"
            >删除公告</el-button
          >
        </div>
      </el-dialog>
    </el-container>
    <div>
      <footers />
    </div>
  </div>
</template>

<script>
// 引入 UserSignin 和 OrderSignin 组件
import UserSignin from "./UserSignin.vue";
import OrderSignin from "./OrderSignin.vue";
import Echarts from "./Echarts.vue";
import footers from "../components/footer.vue";

export default {
  name: "Home",
  components: {
    UserSignin,
    OrderSignin,
    Echarts,
    footers,
  },

  data() {
    return {
      notices: [],
      dialogVisible: false,
      selectedNotice: {},
      users: [], // 所有用户列表
      transits: [], // 所有通行记录
    };
  },
  computed: {},
  mounted() {
    this.fetchNotices();
  },
  methods: {
    async fetchNotices() {
      try {
        const response = await this.$http.get("/api/notices");
        if (Array.isArray(response)) {
          this.notices = response
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, 6);
        } else {
          console.error("API 返回的数据格式不正确:", response);
        }
      } catch (error) {
        console.error("获取通知公告失败:", error);
      }
    },
    showNoticeDetail(notice) {
      this.selectedNotice = notice;
      this.dialogVisible = true;
    },
    async deleteNotice() {
      try {
        await this.$confirm("此操作将永久删除该公告, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await this.$http.delete(`notices/${this.selectedNotice._id}`);
        this.$message.success("公告删除成功");
        this.dialogVisible = false;
        this.notices = this.notices.filter(
          (notice) => notice._id !== this.selectedNotice._id
        );
      } catch (error) {
        if (error.response?.status === 404) {
          this.$message.error("通知公告不存在");
        } else {
          this.$message.error("删除失败，请重试");
        }
      }
    },
    
  },
  filters: {
      truncate(text, length) {
        if (text.length > length) {
          return text.substring(0, length) + "...";
        }
        return text;
      },
      formatDate(dateString) {
      const date = new Date(dateString);
      return `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
    },
    },
  }
</script>

<style scoped lang="less">
.container {
  position: relative;
  height: 85%;
}

.top-left,
.top-right,
.bottom-left,
.bottom-right {
  position: absolute;
  width: 48%;
  height: 53%;
  margin: -1%;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  // justify-content: center;
}

.top-left {
  top: 0;
  left: 0;
  background-color: #f0f0f0;
  overflow-y: auto; /* 添加滚动条以适应大量通知 */
}

h3 {
  padding-left: 5%;
  padding-right: 5%;
}
.top-right {
  position: absolute;
  top: 0%;
  right: 2%;
  margin-left: -5%;
}

.bottom-left {
  position: absolute;
  bottom: 2%;
  left: 0;
  background-color: #f7f3f3;
}

.bottom-right {
  position: absolute;
  bottom: 2%;
  right: 2%;
  background-color: #faf7f7;
}
h3 {
  padding-left: 5%;
  padding-right: 5%;
}

.top-left {
  overflow-y: auto; /* 添加滚动条以适应大量通知 */
}

ul {
  list-style-type: none;
  padding: 3%;
  padding-top: 10%;
  margin: 0;
  height: 90%;
  overflow-y: auto;
  justify-content: center;

  li {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    &:hover {
      background-color: #e0e0e0;
    }
    &:last-child {
      border-bottom: none;
    }

    .timestamp {
      float: right;
      color: #777;
    }
  }
}
</style>
